export const queueDropdown = [
    {
        value: "Red Queue",
        name: "TANF/CC/FA App Queue",
    },
    {
        value: "Green Queue",
        name: "FA App",
    },
    {
        value: "Blue Queue",
        name: "Review",
    },
    {
        value: "IR Queue",
        name: "Interim Report",
    },
    {
        value: "Purple Queue",
        name: "Change/Verification",
    },
    {
        value: "HSA Queue",
        name: "Triage/Support",
    },
    {
        value: "LIEAP Queue",
        name: "LIEAP Queue",
    },
    // {
    //     value: "EmploymentServices",
    //     name: "Employment Services Queue",
    // }
  ];
  